const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "j77rae43fa",
  x1: "0%",
  x2: "92.718%",
  y1: "37.461%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FCB961"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#EB38C2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1EC1FE"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#j77rae43fa)",
  fillOpacity: 0.4,
  fillRule: "evenodd",
  d: "M375.95.946c207.412 0 375.552 168.141 375.552 375.552 0 207.413-168.14 375.553-375.552 375.553C168.539 752.051.398 583.911.398 376.498.398 169.087 168.539.946 375.95.946z"
});
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 752,
    height: 753,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.82fccdcc68d35291884dfd3c6f0f0cff.svg";
export { ForwardRef as ReactComponent };